export const BANNER_1 = {
    img: 'https://picker-oss.oss-cn-beijing.aliyuncs.com/20200113/c8dfb513fcf89af09e91bac511424c89.jpg_compress',
    color: 'cyan',
    titleCss: {
        right: '80px',
        top: '36px',
        color: '#51889A',
        fontWeight: 'lighter',
        fontSize: '35px'
    },
    summaryCss: {
        right: '80px',
        top: '85px',
        color: '#51889A',
        fontWeight: 'lighter',
        fontSize: '14px'
    },
    contentCss: {
        right: '80px',
        top: '145px',
        color: '#51889A',
        fontWeight: 'lighter',
        fontSize: '13px',
        width: '300px',
        textAlign: 'right'
    }
};
export const BANNER_2 = {
    img: 'https://picker-oss.oss-cn-beijing.aliyuncs.com/20200113/bd147f3a32b8bec2e41d9ad7024a8247.jpg_compress',
    color: 'pink',
    titleCss: {
        left: '80px',
        top: '36px',
        color: 'rgb(255,119,149)',
        fontWeight: 'lighter',
        fontSize: '35px'
    },
    summaryCss: {
        left: '80px',
        top: '95px',
        color: 'rgb(255,119,149)',
        fontWeight: 'lighter',
        fontSize: '14px'
    },
    contentCss: {
        left: '80px',
        top: '145px',
        color: 'rgb(255,119,149)',
        fontWeight: 'lighter',
        fontSize: '13px',
        width: '520px',
        textAlign: 'left'
    }
}
export const BANNER_3 = {
    img: 'https://picker-oss.oss-cn-beijing.aliyuncs.com/20200113/79116e68ad1f09b13fca016b5c4ce1a8.jpg_compress',
    color: 'cyan',
    titleCss: {
        right: '80px',
        top: '36px',
        color: '#51889A',
        fontWeight: 'lighter',
        fontSize: '35px'
    },
    summaryCss: {
        right: '80px',
        top: '85px',
        color: '#51889A',
        fontWeight: 'lighter',
        fontSize: '14px'
    },
    contentCss: {
        right: '80px',
        top: '145px',
        color: '#51889A',
        fontWeight: 'lighter',
        fontSize: '13px',
        width: '520px',
        textAlign: 'right'
    }
}
export const BANNER_4 = {
    img: 'https://picker-oss.oss-cn-beijing.aliyuncs.com/20200115/1eaf2346750b72a3b1bcffacc09be3cf.jpeg_compress',
    color: 'pink',
    titleCss: {
        right: '80px',
        top: '36px',
        color: 'rgb(255,119,149)',
        fontWeight: 'lighter',
        fontSize: '35px'
    },
    summaryCss: {
        right: '80px',
        top: '85px',
        color: 'rgb(255,119,149)',
        fontWeight: 'lighter',
        fontSize: '14px'
    },
    contentCss: {
        right: '80px',
        top: '145px',
        color: 'rgb(255,119,149)',
        fontWeight: 'lighter',
        fontSize: '13px',
        width: '300px',
        textAlign: 'right'
    }
};